import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: {},
  loading: true,
  formLoader: false,
  search: null,
  cs_search: null,
};

const loaderSlice = createSlice({
  name: "loader",
  initialState,
  reducers: {
    showLoader: (state) => {
      state.loading = true;
    },
    hideLoader: (state) => {
      state.loading = false;
    },
    showFormLoader: (state) => {
      state.formLoader = true;
    },
    hideFormLoader: (state) => {
      state.formLoader = false;
    },
    callSearch: (state, action) => {
      state.search = action.payload;
    },
    callCaseStudySearch: (state, action) => {
      state.cs_search = action.payload;
    },
  },
});

// Export actions
export const {
  showLoader,
  hideLoader,
  showFormLoader,
  hideFormLoader,
  callSearch,
  callCaseStudySearch,
} = loaderSlice.actions;

// Export reducer
export default loaderSlice.reducer;
